import React from 'react'
import { I18n } from '@front/volcanion'
import { UserUtils } from '@front/volcanion/utils'

import { Icon, Box, IconButton, Grid, InputAdornment } from '@mui/material'
import { TextField, SingleOptionSelectorField, ModelAutocompleteField, NumberField } from '@front/squirtle'

const InputLabelProps = {
  sx: {
    fontSize: 22,
    color: 'primary.main',
  }
}


const PassengerExtra = ({ onDecrementLoadCount, onIncrementLoadCount, max_load }) => (
  <Box flex={1} display='flex' flexDirection='column' gap={2}>
    <NumberField
      label={I18n.t('passenger.number.label')}
      name={'load_count'}
      type='number'
      minValue={0}
      maxValue={max_load}
      InputLabelProps={InputLabelProps}
      inputProps={{ sx: { textAlign: 'center' } }}
      InputProps={{
        startAdornment: <InputAdornment position='start'>{
          <IconButton sx={{ color: 'grayLight', }} onClick={onDecrementLoadCount}>
            <Icon sx={{ fontSize: 16 }}>{'arrow_back_ios'}</Icon>
          </IconButton>
        }</InputAdornment>,
        endAdornment: <InputAdornment position='end'>{
          <IconButton sx={{ color: 'grayLight' }} onClick={onIncrementLoadCount}>
            <Icon sx={{ fontSize: 16 }}>{'arrow_forward_ios'}</Icon>
          </IconButton>
        }</InputAdornment>
      }}
    />
    <SingleOptionSelectorField name={'luggage'} label={I18n.t('luggage.label', { count: 2 })} _label={InputLabelProps} />
  </Box>
)

const PassengerInfo = ({ normalizePhone, displayPassengerText, displayPassengerList, onCompanyuserChange, disabledPassenger, getCompanyuserFilter, getCompanyuserValidate, companyuser_watchers }) =>
  <Box flex={1} >
    <Grid container spacing={2}>
      <Grid item xs={12} hidden={!displayPassengerText}>
        <TextField
          name={'passenger_name'}
          label={I18n.t('passenger.label', { count: 1 })}
          InputLabelProps={InputLabelProps}
          disabled={disabledPassenger}
          required={!!displayPassengerText}
        />
      </Grid>
      <Grid item xs={12} hidden={!displayPassengerList}>
        <ModelAutocompleteField
          name='selected_companyuser_id'
          model_name='companyuser'
          label={I18n.t('passenger.label', { count: 1 })}
          afterUserChange={onCompanyuserChange}
          searchMode='search'
          searchQuery={'startsWith'}
          autocompleteMutator={q => ({
            or: [
              { contact: { last_name: { startsWith: q } } },
              { contact: { first_name: { startsWith: q } } }
            ]
          })}
          labelKeys={['label']}
          config={{
            mutator: elem => ({
              label: UserUtils.getFormatedName(elem?.contact),
              ...elem
            }),
            populate: ['contact'],
            forced_filter: getCompanyuserFilter(...companyuser_watchers),
            validate_filter: getCompanyuserValidate,
            watchers: companyuser_watchers
          }}
          renderInputProps={{ InputLabelProps }}
          selectFirst={false}
          debounceTime={400}
          required={!!displayPassengerList}
        />
      </Grid>
      <Grid item xs={12} hidden={!displayPassengerList && !displayPassengerText}>
        <TextField
          name={'passenger_number'}
          label={I18n.t('gsm.label', { count: 1 })}
          InputLabelProps={InputLabelProps}
          disabled={disabledPassenger}
          normalize={normalizePhone}
          required
        />
      </Grid>
    </Grid>

  </Box>

const PassengerPopup = ({ displayGuestField, ...rest }) => (
  <Box display='flex' flexDirection='column' gap={5}>
    <Box display='flex' justifyContent='space-between' gap={10}>
      <PassengerInfo {...rest} />
      <PassengerExtra {...rest} />
    </Box>
    {!!displayGuestField && <SingleOptionSelectorField
      name={'guest'}
      optionLabel={I18n.t('order.guest_booking')}
      _label={InputLabelProps}
      clearOnEmpty={false}
      getOptionLabelProps={() => ({ labelPlacement: 'end' })}
    />
    }
  </Box>
)


export default React.memo(PassengerPopup)
